import React, { Fragment } from 'react'
import { Breadcrumb, Card, Icon, Modal, Row } from 'antd'
import List from './List'
import BudgetCont, { BUDGET_TYPE_INTERNAL } from '../../../components/Common/Budgets/BudgetCont'

function Budgets(props) {
  const { visible, option, onCancel, budget } = props
  return (
    <Fragment>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>
              {option === BUDGET_TYPE_INTERNAL ? 'Corporate' : 'Sales'}
            </Breadcrumb.Item>
            <Breadcrumb.Item>Budgets</Breadcrumb.Item>
          </Breadcrumb>
          <h1>
            {' '}
            <Icon type="credit-card" style={{ marginRight: 10, color: '#48c94c' }} />
            Budgets
          </h1>
          <p>View list Budgets.</p>
        </Row>
      </Card>
      <Card style={{ margin: 10 }}>
        <Modal
          visible={visible}
          title={'Budget'}
          onCancel={onCancel}
          destroyOnClose={true}
          footer={null}
          width={'75%'}>
          <BudgetCont
            showList={true}
            onCancel={(updated) => {
              if (updated) {
                props.fetch()
                props.onCancel()
              }
            }}
            oldBudget={budget}
            option={option}
          />
        </Modal>
        <List {...props} />
      </Card>
    </Fragment>
  )
}

Budgets.propTypes = {}
Budgets.defaultProps = {}

export default Budgets
